/* C526 (Justin 2026-10-28): Clear cart on the cart page, as on ninjatransfers.com (NT assets/nt-cart-actions.js,
   the Clear cart piece and its confirm dialog). The button (snippets/np-cart-clear.liquid) asks first, then
   /cart/clear.js and a full reload: the subtotal, upsell rails and share link live outside the re-rendered cart form.
   Delegated on document, so it survives the cart form's innerHTML re-renders. Loaded by sections/main-cart.liquid. */
(function () {
  if (window.__npCartClear) return;
  window.__npCartClear = true;

  var css =
    '.np-cc-ov{position:fixed;inset:0;z-index:10050;background:rgba(17,17,17,.45);display:flex;align-items:center;justify-content:center;padding:16px;}' +
    '.np-cc-box{background:#fff;border-radius:14px;box-shadow:0 20px 50px rgba(0,0,0,.25);width:100%;max-width:440px;max-height:calc(100vh - 32px);display:flex;flex-direction:column;overflow:hidden;font-family:inherit;color:#111;}' +
    '.np-cc-hd{padding:20px 20px 6px;}' +
    '.np-cc-title{font-size:18px;font-weight:700;line-height:1.3;margin:0;}' +
    '.np-cc-msg{font-size:14px;line-height:1.45;color:#555;margin:6px 0 0;}' +
    '.np-cc-ft{display:flex;gap:10px;justify-content:flex-end;padding:14px 20px 20px;border-top:1px solid #f0f0f0;}' +
    '.np-cc-btn{appearance:none;border-radius:8px;padding:10px 18px;font-family:inherit;font-size:14px;font-weight:600;line-height:1.2;cursor:pointer;border:1px solid #d6d7db;background:#fff;color:#111;}' +
    '.np-cc-btn:hover{border-color:#111;}' +
    '.np-cc-btn--danger{background:#DC2626 !important;border-color:#DC2626 !important;color:#fff !important;}' +
    '.np-cc-btn--danger:hover{background:#B91C1C !important;border-color:#B91C1C !important;}' +
    '.np-cc-btn[disabled]{opacity:.5;cursor:default;}' +
    '@media (max-width:480px){.np-cc-ft{flex-direction:column-reverse;}.np-cc-btn{width:100%;}}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  function confirmClear() {
    var ov = document.createElement('div');
    ov.className = 'np-cc-ov';
    ov.innerHTML =
      '<div class="np-cc-box" role="dialog" aria-modal="true" aria-labelledby="np-cc-title">' +
        '<div class="np-cc-hd"><p class="np-cc-title" id="np-cc-title">Clear your cart?</p>' +
          '<p class="np-cc-msg">This removes every item from your cart. This can’t be undone.</p></div>' +
        '<div class="np-cc-ft">' +
          '<button type="button" class="np-cc-btn" data-np-cc-cancel>Cancel</button>' +
          '<button type="button" class="np-cc-btn np-cc-btn--danger" data-np-cc-ok>Clear cart</button>' +
        '</div>' +
      '</div>';
    function close() {
      document.removeEventListener('keydown', onKey);
      if (ov.parentNode) ov.parentNode.removeChild(ov);
    }
    function onKey(e) { if (e.key === 'Escape') close(); }
    ov.addEventListener('click', function (e) {
      if (e.target === ov || e.target.closest('[data-np-cc-cancel]')) { close(); return; }
      var ok = e.target.closest('[data-np-cc-ok]');
      if (!ok || ok.disabled) return;
      ok.disabled = true;
      ok.textContent = 'Clearing…';
      fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .then(function () { window.location.reload(); }, function () { window.location.reload(); });
    });
    document.addEventListener('keydown', onKey);
    document.body.appendChild(ov);
    ov.querySelector('[data-np-cc-ok]').focus();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-np-cart-clear]');
    if (!btn) return;
    e.preventDefault();
    confirmClear();
  });
})();
